import { render, staticRenderFns } from "./mailboxManagement.vue?vue&type=template&id=f44a84fc&scoped=true&"
import script from "./mailboxManagement.vue?vue&type=script&lang=js&"
export * from "./mailboxManagement.vue?vue&type=script&lang=js&"
import style0 from "./mailboxManagement.vue?vue&type=style&index=0&id=f44a84fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44a84fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f44a84fc')) {
      api.createRecord('f44a84fc', component.options)
    } else {
      api.reload('f44a84fc', component.options)
    }
    module.hot.accept("./mailboxManagement.vue?vue&type=template&id=f44a84fc&scoped=true&", function () {
      api.rerender('f44a84fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/mailboxManagement.vue"
export default component.exports